import { writable } from 'svelte/store';

export let api="/api/";
if((window.location.href).includes('localhost:5000')) { api="http://fotoskoly.jahnet.eu/api/"; }

export let path = writable("/");
export let api_url = writable(api);
export let bgColor = writable("rgba( 13, 110, 253, .9)");
export let errorColor = writable("red");
